import { render, staticRenderFns } from "./ty.vue?vue&type=template&id=25c67e20"
import script from "./ty.vue?vue&type=script&lang=js"
export * from "./ty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c67e20')) {
      api.createRecord('25c67e20', component.options)
    } else {
      api.reload('25c67e20', component.options)
    }
    module.hot.accept("./ty.vue?vue&type=template&id=25c67e20", function () {
      api.rerender('25c67e20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/ty.vue"
export default component.exports